export const GUYUANE_PHONE_REGION = '594'
export const MARTINIQUE_PHONE_REGION = '596'
export const FRENCH_PACIFIC_DOM_PHONE_REGION = '262'
export const GUADELOUPE_PHONE_REGION = '590'
